<template>
  <!--
    Fullscreen lightbox for inspecting a sample card. Click backdrop
    or × to close. Arrow keys cycle through the 5 sample cards if
    the parent passes the full ``cards`` array.
  -->
  <div class="lightbox-backdrop" @click.self="$emit('close')">
    <button class="close-btn" @click="$emit('close')" aria-label="Close">×</button>

    <button
      v-if="cards && cards.length > 1"
      class="nav-btn left"
      @click="$emit('prev')"
      aria-label="Previous card"
    >‹</button>

    <div class="lightbox-card">
      <img
        v-if="card?.image_url || card?.imageUrl"
        :src="card.image_url || card.imageUrl"
        :alt="card.card_name || card.cardName"
      />
      <div v-else class="missing">No image yet</div>
      <div class="caption">{{ card?.card_name || card?.cardName || '' }}</div>
    </div>

    <button
      v-if="cards && cards.length > 1"
      class="nav-btn right"
      @click="$emit('next')"
      aria-label="Next card"
    >›</button>
  </div>
</template>

<script setup>
import { onMounted, onUnmounted } from 'vue'

defineProps({
  card: { type: Object, default: null },
  cards: { type: Array, default: () => [] },
})
const emit = defineEmits(['close', 'prev', 'next'])

function onKey(e) {
  if (e.key === 'Escape') emit('close')
  else if (e.key === 'ArrowLeft') emit('prev')
  else if (e.key === 'ArrowRight') emit('next')
}
onMounted(() => window.addEventListener('keydown', onKey))
onUnmounted(() => window.removeEventListener('keydown', onKey))
</script>

<style scoped>
.lightbox-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.close-btn {
  position: absolute;
  top: 18px;
  right: 24px;
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(195, 169, 255, 0.3);
  border-radius: 50%;
  color: #f3e9d2;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: inherit;
}
.close-btn:hover { background: rgba(255, 255, 255, 0.12); }

.nav-btn {
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(195, 169, 255, 0.3);
  width: 56px;
  height: 56px;
  border-radius: 50%;
  color: #f3e9d2;
  font-size: 32px;
  line-height: 1;
  cursor: pointer;
  font-family: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
}
.nav-btn:hover { background: rgba(255, 255, 255, 0.12); }
.nav-btn.left { margin-right: 24px; }
.nav-btn.right { margin-left: 24px; }

.lightbox-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  max-height: 100%;
  max-width: 100%;
}
.lightbox-card img {
  max-height: 80vh;
  max-width: 100%;
  height: auto;
  width: auto;
  border-radius: 10px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.6);
}
.caption {
  font-family: 'Cinzel', serif;
  color: #C9A94E;
  font-size: 18px;
  letter-spacing: 0.06em;
}
.missing {
  color: rgba(212, 196, 232, 0.4);
  font-style: italic;
  padding: 60px;
}
</style>
